export default __webpack_public_path__ + "locales/bg/PDFFormDialog.json?hash=f66bd252e46b2c3ea60eef9d2027fe04";